import type { ComponentType } from "react";

import { lazy } from "react";

import ErrorLog from "~/pages/ErrorLog";
import MyCommissions from "~/pages/myCommissions";
import AppInstalls from "~settings/appInstalls";
import LinkedEmail from "~settings/linkedEmail";
import Preferences from "~settings/preferences";
import Shortcuts from "~settings/shortcuts";

const NotificationSettings = lazy(() => import("~settings/notifications"));
const Security = lazy(() => import("~settings/security"));

export type PreferenceSection = "myPages" | "preferences";

export interface PreferenceTab {
	Component: ComponentType<{ hosted?: boolean }>;
	icon: string;
	id: string;
	labelKey: string;
	section: PreferenceSection;
}

interface PreferenceTabOptions {
	canShowInstall: boolean;
	showMyCommissions: boolean;
}

const buildPreferenceTabs = ({ canShowInstall, showMyCommissions }: PreferenceTabOptions): PreferenceTab[] => [
	{
		Component: Preferences,
		icon: "tune",
		id: "preferences",
		labelKey: "preferences.tabs.preferences",
		section: "preferences"
	},
	{
		Component: LinkedEmail,
		icon: "mail",
		id: "linked-email",
		labelKey: "preferences.tabs.linkedEmail",
		section: "preferences"
	},
	{
		Component: NotificationSettings,
		icon: "notifications",
		id: "notifications",
		labelKey: "preferences.tabs.notifications",
		section: "preferences"
	},
	{
		Component: Security,
		icon: "shield",
		id: "security",
		labelKey: "preferences.tabs.security",
		section: "preferences"
	},
	{
		Component: Shortcuts,
		icon: "keyboard",
		id: "shortcuts",
		labelKey: "preferences.tabs.shortcuts",
		section: "preferences"
	},
	...(canShowInstall
		? [
				{
					Component: AppInstalls,
					icon: "install_mobile",
					id: "app-installs",
					labelKey: "preferences.tabs.appInstalls",
					section: "preferences" as const
				}
			]
		: []),
	{
		Component: ErrorLog,
		icon: "bug_report",
		id: "error-log",
		labelKey: "preferences.tabs.errorLog",
		section: "preferences"
	},
	...(showMyCommissions
		? [
				{
					Component: MyCommissions,
					icon: "percent",
					id: "my-commissions",
					labelKey: "preferences.tabs.myCommissions",
					section: "myPages" as const
				}
			]
		: [])
];

export default buildPreferenceTabs;
